module.exports = __webpack_public_path__ + "img/reviews-img-2-test.379224f3.jpg";